"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCell = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importDefault(require("react"));
const CellWrapper_1 = require("../CellWrapper/CellWrapper");
const BaseCell = (props) => react_1.default.createElement(CellWrapper_1.CellWrapper, Object.assign({}, props), props.getValue());
exports.BaseCell = BaseCell;
